import React, { Component, useState, useEffect, useContext } from 'react';
import styles from './DirectoryCardArea.module.scss';
import DirectoryCard from './directory-card/DirectoryCard';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import { DoctorIcon, HospitalIcon, PharmacyIcon, SearchIcon } from '../icons/Icons';

const DirectoryCardArea = (props: any) => {
  const appContext = useContext(AppContext);
  let currentListType: DirectoryListType;

  switch (appContext.directoryListType) {
    case DirectoryListType.doctor:
      currentListType = DirectoryListType.doctor;
      break;
    case DirectoryListType.facility:
      currentListType = DirectoryListType.facility;
      break;
    case DirectoryListType.pharmacy:
      currentListType = DirectoryListType.pharmacy;
      break;
    case DirectoryListType.all:
      currentListType = DirectoryListType.all;
      break;
    default:
      currentListType = DirectoryListType.none;
      break;
  }

  return (
    <div className={styles.directoryCardContainer}>
      <DirectoryCard title="Find a doctor" currentListType={currentListType} listType={DirectoryListType.doctor}>
        <DoctorIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.doctor} />
      </DirectoryCard>
      <DirectoryCard title="Find a hospital, facility, or other service" currentListType={currentListType} listType={DirectoryListType.facility}>
        <HospitalIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.facility} />
      </DirectoryCard>
      <DirectoryCard title="Find a pharmacy" currentListType={currentListType} listType={DirectoryListType.pharmacy}>
        <PharmacyIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.pharmacy} />
      </DirectoryCard>
      <DirectoryCard title="Find by name or keyword" currentListType={currentListType} listType={DirectoryListType.all}>
        <SearchIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.all} />
      </DirectoryCard>
    </div>
  );
};

export default DirectoryCardArea;
